export default __webpack_public_path__ + "5ab801f28c05115128339c2a52596eaa.png";